
import {Component, Vue} from 'vue-property-decorator'
import { VAlert } from 'vuetify/lib'

@Component({
  name: 'Alert',
  extends: VAlert as any,
})
export default class Alert extends Vue {}
